"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdatedSearchData = getUpdatedSearchData;
exports.getUpdatedSearchDataForConsultADoctor = getUpdatedSearchDataForConsultADoctor;
function getUpdatedSearchData(result) {
  const {
    specialityList = [],
    doctorList = [],
    hospitalList = []
  } = result;
  return specialityList.map(speciality => {
    return {
      ...speciality,
      type: 'speciality',
      title: speciality.name + ' in Specialties'
    };
  }).concat(doctorList.map(doctor => {
    return {
      ...doctor,
      type: 'practitioner',
      title: doctor.name + ' in Doctors',
      subTitle: doctor.specialization
    };
  })).concat(hospitalList.map(hospital => {
    return {
      ...hospital,
      type: 'facility',
      title: hospital.name,
      subTitle: hospital.hospitalType
    };
  }));
}
function getUpdatedSearchDataForConsultADoctor(result) {
  const specialityList = result.filter(item => item.categoryName === 'Specialities');
  const doctorList = result.filter(item => item.categoryName === 'Doctors');
  const hospitalList = result.filter(item => item.categoryName === 'Facilities');
  return specialityList.map(speciality => {
    return {
      ...speciality,
      type: 'speciality',
      title: speciality.name + ' in ' + speciality.categoryName
    };
  }).concat(doctorList.map(doctor => {
    return {
      ...doctor,
      type: 'practitioner',
      title: doctor.name + ' in Doctors',
      subTitle: doctor.specialization
    };
  })).concat(hospitalList.map(hospital => {
    return {
      ...hospital,
      type: 'facility',
      title: hospital.name,
      subTitle: hospital.hospitalType
    };
  }));
}